<template>
    <div class="questions">

        <div class="question" v-for="(question, index) in questions">

            <div class="question card">
                <div class="card-body">

                    <span class="card-title">{{question.question.question}}</span>

                    <div v-if="question.question.question_type_id === 1 || question.question.question_type_id === 5" class="multiple_choice">
                       <div v-for="(choice) in question.question.question_choices" class="mt-2 d-flex justify-content-start align-items-top">

                           <span class="mr-2 flex-grow-0 flex-shrink-0">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="choice.incorrect">
                                <path d="M12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12C23.625 5.57812 18.4219 0.375 12 0.375ZM12 21.375C6.82031 21.375 2.625 17.1797 2.625 12C2.625 6.82031 6.82031 2.625 12 2.625C17.1797 2.625 21.375 6.82031 21.375 12C21.375 17.1797 17.1797 21.375 12 21.375ZM16.7719 9.08438L13.8563 12L16.7719 14.9156C16.9922 15.1359 16.9922 15.4922 16.7719 15.7125L15.7125 16.7719C15.4922 16.9922 15.1359 16.9922 14.9156 16.7719L12 13.8563L9.08438 16.7719C8.86406 16.9922 8.50781 16.9922 8.2875 16.7719L7.22812 15.7125C7.00781 15.4922 7.00781 15.1359 7.22812 14.9156L10.1437 12L7.22812 9.08438C7.00781 8.86406 7.00781 8.50781 7.22812 8.2875L8.2875 7.22812C8.50781 7.00781 8.86406 7.00781 9.08438 7.22812L12 10.1437L14.9156 7.22812C15.1359 7.00781 15.4922 7.00781 15.7125 7.22812L16.7719 8.2875C16.9922 8.50781 16.9922 8.86406 16.7719 9.08438V9.08438Z" fill="red"/>
                            </svg>

                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  v-if="choice.correct">
                                <path d="M12 0.375C5.57967 0.375 0.375 5.57967 0.375 12C0.375 18.4203 5.57967 23.625 12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57967 18.4203 0.375 12 0.375ZM12 2.625C17.1812 2.625 21.375 6.81802 21.375 12C21.375 17.1812 17.182 21.375 12 21.375C6.81881 21.375 2.625 17.182 2.625 12C2.625 6.81881 6.81802 2.625 12 2.625ZM18.5721 8.73127L17.5157 7.66636C17.2969 7.44581 16.9408 7.44436 16.7202 7.66317L10.0943 14.2358L7.29159 11.4103C7.07283 11.1898 6.71667 11.1883 6.49612 11.4071L5.43117 12.4635C5.21062 12.6822 5.20917 13.0384 5.42798 13.259L9.68334 17.5488C9.90211 17.7693 10.2583 17.7708 10.4788 17.552L18.5689 9.52678C18.7894 9.30797 18.7908 8.95181 18.5721 8.73127V8.73127Z" fill="green"/>
                            </svg>

                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!choice.incorrect && !choice.correct">
                                <path d="M12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12C23.625 5.57812 18.4219 0.375 12 0.375ZM12 21.375C6.82031 21.375 2.625 17.1797 2.625 12C2.625 6.82031 6.82031 2.625 12 2.625C17.1797 2.625 21.375 6.82031 21.375 12C21.375 17.1797 17.1797 21.375 12 21.375Z" fill="#dddddd"/>
                            </svg>
                           </span>

                           <span class="flex-grow-1">
                                {{ choice.choice}}
                           </span>
                       </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EvalQuestionReceipt',
        props: {
            questions: null,
            evaluation: null,
        },
    }
</script>

<style lang="scss" scoped>
    @import "../styles/components/evalquestion.scss";
</style>
